<script>
import { mapGetters } from 'vuex'
export default 
{
    name: 'channel-filter',

    computed:
    {
        ...mapGetters(['clients']),

        uid()
        {
            return `channel-filter-select-${this._uid}`
        },

        selectedClient()
        {
            return this.clients.data.find(el => el.id == this.selectedId)
        }
    },

    methods:
    {
        changed()
        {
            this.$nextTick(() => {
                const selected = this.selectedClient ? this.selectedClient.channel_id : null
                this.$router.push({ query: { channel: selected }})
            })
        },
    },

    data()
    {
        return {
            selectedId: null,
        }
    },

    mounted()
    {
        if (!this.clients || !this.clients.data)
            this.$store.dispatch('clientsFetch')
    },
    
}
</script>

<template>
<div class="row">
    <select class="form-control col" :id="uid" v-if="clients && clients.data && clients.data.length" v-model="selectedId" @input="changed">
        <option :value="null">All</option>
        <option v-for="client in clients.data" :key="client.id" :value="client.id">
                {{ client.name }}
        </option>
    </select>
</div>
</template>




// WEBPACK FOOTER //
// src/components/elements/ChannelFilter.vue